
import { Component, Prop, Vue } from 'vue-property-decorator'
import Bridge from '@/utils/bridge'
import { backToBefore } from '@/utils/h5ToApp'
import { Action, Getter } from 'vuex-class'
import ChangeStore from '@/components/ChangeStore/index.vue'
import { pxToVw } from '@/utils/pxToVw'

@Component({
  components: {
    ChangeStore
  }
})
export default class BackNav extends Vue {
  @Prop({default: true}) showBack!: boolean
  @Prop({default: true}) showBackHome!: boolean
  @Prop({default: false}) showChangeStore!: boolean // 显示切换店铺
  @Prop({default: true}) showTitle!: boolean
  @Prop({default: ''}) title?: string
  @Prop({default: '#333'}) color?: string // 字体图标颜色
  @Prop({default: '#fff'}) bgColor?: string // 背景颜色
  @Prop({default: () => {}}) readonly handleBack?: () => void // 返回
  @Prop({default: () => {}}) readonly handleHomeBack?: () => void // 返回首页
  @Getter topSafetyHeight!: number
  @Action setOrderFromPage!: (val: string) => void
  get topSafetyHeightCss(): string {
    return pxToVw(this.topSafetyHeight)
  }
  
  goBack () {
    if (this.handleBack) {
      this.handleBack()
    } else {
      this.$router.back()
    }
  }

  /**
   * 直接跳转回首页
   */
  goHome () {
    if (this.$store.state.order.orderFromPage === '1') {
      this.setOrderFromPage('0')
      backToBefore()
      return false
    }
    if (this.handleHomeBack) {
      this.handleHomeBack()
    } else {
      this.$goHomeBack()
    }
  }
}
